export default class AccountMenuController {
	/* @ngInject */
	constructor($routeParams, $rootScope) {
		this.$rootScope = $rootScope;

		this.entries = {
			infos:         {
				icon: 'fa-cogs',
			},
			password:      {
				icon: 'fa-key',
			},
		};

		this.entries.mailing = {
			icon: 'fa-envelope',
		};
		this.entries.workflow = {
			icon: 'fa-users',
		};

		this.page = $routeParams.page;
	}

	isAdmin() {
		return this.$rootScope.context.profil.admin;
	}
}
